"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketManager = void 0;
var socket_io_1 = __importStar(require("../../socket.io"));
var util_1 = require("../../util");
var log_1 = require("../../util/log");
// socket 重连次数
var reconnectionAttempts = 10;
/**
 * 非编辑公共 Websocket 管理器
 *
 * @class WebsocketManager
 * @implements {IWebsocketManager}
 */
var WebsocketManager = /** @class */ (function () {
    function WebsocketManager(options) {
        var _this = this;
        this.options = options;
        this.socket = null;
        this.socketStatus = 0 /* INIT */;
        /**
         * 连接成功
         *
         */
        this.handleConnect = function () {
            log_1.ConnectionLog.info("socket io connect readyState: " + _this.socket.io.readyState + ", id:" + _this.socket.id);
            _this.options.featureMessageCenterReceiver.onConnect();
        };
        /**
        * 连接错误
        *
        * @param {*} msg
        */
        this.handleError = function (connectError) {
            log_1.ConnectionLog.info("socket io error, type:" + (connectError === null || connectError === void 0 ? void 0 : connectError.type) + ", message:" + (connectError === null || connectError === void 0 ? void 0 : connectError.message) + ", description:" + (connectError === null || connectError === void 0 ? void 0 : connectError.description));
            _this.disConnect(util_1.JsonUtil.jsonStringify(connectError) + " socket io error Closed by client.");
        };
        /**
         * 重连失败
         *
         * @private
         * @param {*} msg
         */
        this.handleReconnectFailed = function (msg) {
            // 在规定重连次数内不能连接上时触发
            log_1.ConnectionLog.info('socket io reconnect_failed');
            _this.disConnect(util_1.JsonUtil.jsonStringify(msg) + " reconnect_failed Closed by client.");
        };
        /**
         * 连接失败
         *
         * @private
         * @param {*} message
         */
        this.handleConnectFailed = function (message) {
            log_1.ConnectionLog.info('socket io connect_failed');
            _this.disConnect(util_1.JsonUtil.jsonStringify(message) + "  connect_failed Closed by client.");
        };
        /**
         * 自定义事件，收到服务器推送消息
         *
         * @param {*} message
         */
        this.handleMessageFromServerPush = function (message) {
            _this.options.featureMessageCenterReceiver.onGetMessageFromServerPush(message);
        };
        /**
         * 自定义事件,提交消息之后的服务器回包消息
         *
         * @private
         * @param {*} message
         */
        this.handlePost = function (message) {
            var _a, _b;
            (_b = (_a = _this.options.featureMessageCenterReceiver).onPostFromServer) === null || _b === void 0 ? void 0 : _b.call(_a, message);
        };
    }
    WebsocketManager.prototype.dispose = function () {
        this.disConnectSocket();
    };
    WebsocketManager.prototype.connect = function () {
        var socket = socket_io_1.default("wss://" + this.options.host, {
            query: {
                gtag: this.options.gtag,
            },
            transports: socket_io_1.DEFAULT_TRANSPORT_MODE,
            reconnection: true,
            reconnectionAttempts: reconnectionAttempts,
            reconnectionDelay: socket_io_1.WEBSOCKET_CONFIG.reconnectionDelay,
            reconnectionDelayMax: socket_io_1.WEBSOCKET_CONFIG.reconnectionDelayMax,
            randomizationFactor: socket_io_1.WEBSOCKET_CONFIG.randomizationFactor,
            timeout: socket_io_1.WEBSOCKET_CONFIG.connectTimeout,
            path: '/socket.io',
        });
        this.socket = socket;
        if (!this.socket) {
            log_1.ConnectionLog.warn('socket is null');
            return;
        }
        this.socket.on('get', this.handleMessageFromServerPush);
        this.socket.on('post', this.handlePost);
        this.socket.on('connect', this.handleConnect);
        this.socket.on('connect_failed', this.handleConnectFailed);
        this.socket.on('error', this.handleError);
        this.socket.on('reconnect_failed', this.handleReconnectFailed);
    };
    WebsocketManager.prototype.disConnect = function (reason) {
        log_1.ConnectionLog.info("socket io disconnect reason: " + reason);
        this.disConnectSocket();
        this.options.featureMessageCenterReceiver.onConnectFail();
    };
    WebsocketManager.prototype.sendMessage = function (message) {
        if (message && this.socket) {
            this.socket.emit('post', message);
        }
    };
    WebsocketManager.prototype.disConnectSocket = function () {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    };
    return WebsocketManager;
}());
exports.WebsocketManager = WebsocketManager;
